module.exports = __webpack_public_path__ + "static/asthmagram-placement-2c383ab3a1916f61d47dda20a57ac305.png";